'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prefix = require('../prefix');

var _prefix2 = _interopRequireDefault(_prefix);

var _pascalize = require('../utils/pascalize');

var _pascalize2 = _interopRequireDefault(_pascalize);

var _camelize = require('../utils/camelize');

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Mask property support cannot detect directly in WebKit browsers,
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
exports['default'] = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;
    if (_prefix2['default'].js === 'Webkit') {
      var longhand = 'mask-image';
      if ((0, _camelize2['default'])(longhand) in style) {
        return prop;
      }
      if (_prefix2['default'].js + (0, _pascalize2['default'])(longhand) in style) {
        return _prefix2['default'].css + prop;
      }
    }
    return prop;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/css-vendor/lib/plugins/mask.js
// module id = 15
// module chunks = 0